/*
 * The local harness session.
 *
 * There is no core-api in the harness, so there is no session cookie to validate and
 * no Firebase project to sign into. This module stands in for both, for the "local"
 * bundle only, in the same spirit as admin-portal-frontend's VITE_E2E session
 * (src/auth/AuthProvider.tsx): one fixed identity, and a deterministic token the
 * local backends' stubbed verify_id_token accepts.
 *
 * IS_LOCAL_HARNESS is a build-time constant, the CRA answer to that portal's
 * `__E2E__` define: webpack substitutes the env var literally at this use site, so a
 * dev or prod build minifies to `false` and drops every branch guarded by it — the
 * strings below included. It is read from process.env rather than from
 * environments.js's APPLI_ENV_NAME for exactly that reason. It also cannot be turned
 * on without pointing the whole app at 127.0.0.1.
 */
export const IS_LOCAL_HARNESS = process.env.REACT_APP_APPLI_ENV === 'local';

/* The one account admin-portal-frontend's e2e/harness/seed.py creates. */
export const LOCAL_CANDIDATE = {
    email: 'e2e.candidate@appli.test',
    user_type: 'candidate',
    user_id: 'e2e-candidate-uid',
};

/* The password field is kept because the form asks for one; nothing reads it. */
export const LOCAL_PASSWORD = 'local-harness';

/**
 * The session, read from the keys utils/auth already keeps the signed-in user in —
 * so a local session is the same session every page and every test reads.
 */
export const readLocalSession = () => {
    const email = localStorage.getItem('email');
    const userId = localStorage.getItem('user_id');
    if (!email || !userId) return null;
    return {
        email,
        user_type: localStorage.getItem('user_type') || LOCAL_CANDIDATE.user_type,
        user_id: userId,
    };
};

/**
 * What the local backends take in place of the session cookie: the `auth-token`
 * header path that appli-common's db_utils/users_util.enforce_permission documents
 * for local development, carrying the harness's `e2e:<uid>` token.
 */
export const localAuthToken = () => {
    const session = readLocalSession();
    return session ? `e2e:${session.user_id}` : null;
};
